<template>
  <div class="section section--spacing-short section--background-tertiary">

    <div v-if="rawTitle"
         class="wrapper">
      <div class="container">
        <div class="small-width">
          <macro-title :title="rawTitle"
                       add-class="m-slider__title h2 font-weight-bold text-align-center"></macro-title>
        </div>
      </div>
    </div>

    <div class="slider__wrapper">
      <swiper ref="mySwiper"
              v-if="itemsSlider"
              :auto-update="true"
              :options="swiperOptions">
        <swiper-slide v-for="(item, key) in itemsSlider"
                      class="slider__item"
                      :class="[{'slider__item--has-link': item.link}]"
                      :key="'slide-' + key">
          <figure
            class="figure figure--slider"
          >
            <picture v-if="item.feature">
              <img
                :data-src="item.feature[0]"
                class="swiper-lazy"
                width="638"
                height="480"
                :alt="item.alt || item.feature[0]"/>
            </picture>
          </figure>

          <template v-if="item.link">
            <a
              class="slider__item-content"
              :href="item.link"
            >
              <macro-title
                :title="displayDatesRange(item.date_start, item.date_end)"
                add-class="title--small"
              />

              <macro-title
                :title="item.post_title"
                add-class="h3 slider__item-title font-weight-bold"
              />

              <span class="action action--bordered action--bordered-white">
                <span class="action__text">Jetzt ansehen</span>
              </span>

            </a>
          </template>
          <template v-else>
            <div class="slider__item-content">
              <macro-title :title="item.date_start" add-class="title--small"></macro-title>
              <macro-title :title="item.post_title" add-class="h3 font-weight-bold"></macro-title>
            </div>
          </template>


          <div
            v-if="item.feature"
            class="swiper-lazy-preloader swiper-lazy-preloader-black"
          />
        </swiper-slide>

      </swiper>

      <div class="slider-navigation">
        <button class="swiper-button-prev slider__button slider__button--prev">
          <span class="visually-hidden">←</span>
          <v-icon-arrow-left :theme="theme"></v-icon-arrow-left>
        </button>
        <button class="swiper-button-next slider__button slider__button--next">
          <span class="visually-hidden">→</span>
          <v-icon-arrow-right :theme="theme"></v-icon-arrow-right>
        </button>
      </div>
    </div>

    <div v-if="cleanLink.url"
         class="action__container action__container--center m-slider__action">
      <a :href="cleanLink.url"
         class="action action--bordered"
         :target="cleanLink.target === '_blank' ? '_blank' : '_self'">
        <span class="action__text">{{ cleanLink.title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VIconArrowLeft from '../VIcons/VIconArrowLeft.vue';
import VIconArrowRight from '../VIcons/VIconArrowRight.vue';
import VMixins from '../VMixins/VMixins.vue';
import SwiperCore, {Navigation, Keyboard, Lazy} from 'swiper';
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {getPosts} from '../rest-service/rest-service';
import AsyncComputed from 'vue-async-computed';
import MacroTitle from '../MacroTitle/MacroTitle.vue';
import {isWebP} from '../utils/isWebP';

Vue.use(AsyncComputed);

// install Swiper components
SwiperCore.use([Navigation, Keyboard, Lazy]);
export default {
  name: "VSlider",
  mixins: [VMixins],
  components: {
    Swiper,
    SwiperSlide,
    MacroTitle,
    VIconArrowLeft,
    VIconArrowRight
  },
  data() {
    return {
      limit: 8,
      isWebpEnable: true,
      isDataReady: false,
      swiperOptions: {
        slidesPerView: 'auto',
        // Disable preloading of all images
        preloadImages: false,
        watchSlidesVisibility: true,
        // Enable lazy loading
        lazy: {
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          checkInView: true,
        },
        spaceBetween: 27,
        loop: true,
        autoHeight: true, //enable auto height

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          320: {
            centeredSlides: false,
            spaceBetween: 10,
          },
          768: {
            centeredSlides: false,
            spaceBetween: 30,

          },
          1180: {
            centeredSlides: true,
            //initialSlide: -2,
            spaceBetween: 60
          }
        }

      }
    }
  },

  created() {
    isWebP().then(hasWebP => {
      this.isWebpEnable = hasWebP
    })
  },

  mounted() {

  },

  computed: {
    cleanLink() {
      return JSON.parse(this.link.replace(/'/g, '"'))
    },

    theme() {
      return document.head.querySelector('[property~=theme][content]').content
    }
  },

  props: {
    rawTitle: String,
    link: String
  },


  asyncComputed: {
    itemsSlider() {
      /*return Promise.all(this.cleanData.map((item, key) => {

        let imagePromise = new Promise((resolve, reject) => {
          getImage(item.image.ID, (response) => {
            resolve(response)
          })
        })

        return imagePromise.then((value) => {
          item.image.data =  value
          return item
        })

      })).then(values => {
        this.isDataReady = true
        return values
      })*/


      const getNextCourses = () => {
        return new Promise(resolve => {
          getPosts({
            post_type: 'course',
            post_status: 'publish',
            posts_per_page: -1,
            orderby: 'menu_order',
            order: 'DESC',
            suppress_filters: 0,
            lang: this.lang
          }, (response) => {
            resolve(response.data)
          })
        })
      }

      return getNextCourses().then(response => {
        const rawCourse = response.filter(item => item.list)

        let temp = rawCourse.map(item => {
          item.list.map(listItem => {
            listItem.feature = item.feature
            listItem.alt = item.alt
            listItem.id = item.id
            listItem.price = item.price
            listItem.link = item.link
            listItem.type = item.type
            listItem.post_title = item.post_title
            return listItem
          })
          return item.list
        }).flat()

        temp = temp.filter(item => !item.hide_book_button && item.date_start)

        temp = this.sortByDate(temp, 'date_start');

        /*console.log(temp.slice(0, 7))*/

        return temp.slice(0, 7)
      })
    }
  }
}
</script>
